import { getCallAnalysis } from "api/callsAnalysis/callsAnalysis"
import { AxiosError } from "axios"
import { useMutation } from "react-query"
import { notifyApiError } from "util/toasts"

export const useCallsAnalysisMutation = () => {
  return useMutation(getCallAnalysis, {
    onError: (error: AxiosError) => {
      notifyApiError(error)
    },
  })
}
